module.exports = __webpack_public_path__ + "img/app-icon.9660bae2.svg";